import { render, staticRenderFns } from "./treeother.vue?vue&type=template&id=8bd95f22&scoped=true&"
import script from "./treeother.vue?vue&type=script&lang=js&"
export * from "./treeother.vue?vue&type=script&lang=js&"
import style0 from "./treeother.vue?vue&type=style&index=0&id=8bd95f22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd95f22",
  null
  
)

export default component.exports